export default __webpack_public_path__ + "static/media/add_circle.98e5d802.svg";